<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'550'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Url Endpoint
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Escreva a url da requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>

                <v-text-field label="Url Endpoint" :name="'Url Endpoint id ' + requisicaoEditar.id" class="required-field"
                              :key="'Url Endpoint id ' + requisicaoEditar.id"
                              placeholder="Ex. https://www.azi.com.br/" :error-messages="errors.collect('Url Endpoint id ' + requisicaoEditar.id)"
                              v-model="urlEndpoint" v-validate="'required'" maxlength="500" :counter="500"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarUrlEndpointRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            urlEndpoint: null
        }
    },
    computed: {
        requisicaoUrlEndpoint() {
            return this.requisicaoEditar.urlEndpoint
        }
    },
    mounted() {
        this.urlEndpoint = this.requisicaoUrlEndpoint
    },
    methods:{
        confirmar() {
            if(!this.urlEndpoint || this.urlEndpoint.trim().length === 0){
                throw new Error('Url não informada!')
            }
            this.requisicaoEditar.urlEndpoint = this.urlEndpoint
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
